import { render, staticRenderFns } from "./management_incidents.vue?vue&type=template&id=5c64e874"
import script from "./js/management_incident.js?vue&type=script&lang=js&external"
export * from "./js/management_incident.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports